import { CFlexContainer } from "./Container/CFlexContainer";
import { Div } from "./Div";
import { Tag } from "./Tag";
import { UImg } from "./Image/UImg";
import { toMap } from "../../../HA";

export class Code extends CFlexContainer {
    protected initialize(data: any) {
        super.initialize(data);
        this.addClass("code");
        const title = this.get("title");
        const img = this.get("img");
        if (img) {
            this.appendChild(new UImg(img));
        } else if (title) {
            const t = new Div({ class: "ctitle", txt: title });
            this.appendChild(t);
        }
        const body = this.get("b");
        if (body) {
            const b = new Tag({ html: "<code></code>", class: "cbody" });
            if (this.get("raw")) {
                b.setText(body);
            } else {
                b.appendChild(new Tag(toMap(body) as any));
            }
            this.appendChild(b);
        }
    }
}
